module.exports = __webpack_public_path__ + "img/PG1_1-6-259x195.fb5221a3.png";